import {Component, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CommonModule, NgForOf, NgStyle} from "@angular/common";
import {OtpComponent} from "./otp/otp.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ActivatedRoute} from "@angular/router";
import {SipoService} from "../services/SipoService";
import {PdfDto} from "../model/pdf-dto";
import {ConfirmDocumentSignComponent} from "./document-item-sign/confirm-document-sign.component";
import {SignatureLevel, SignerModel, SigningStates} from "../model/signer-model";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FileModel} from "../model/file-model";
import {TranslatePipe} from "@ngx-translate/core";
import {EvidenceSvgPipe} from "../../shared/pipes/evidence-svg.pipe";
import {IdCardComponent} from "../../shared/components/id-card/id-card.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {SkeletonModule} from "primeng/skeleton";
import {ReactiveFormsModule} from "@angular/forms";

interface mockDocumentForSigning {
    document: {
        img: string;
        signerName: string;
        signaturePosition: {
            bottom: string;
            left: string;
        },
        height: number;
        width: number;
    }[];
}

@Component({
    selector: 'app-document-signing',
    standalone: true,
    imports: [
        NgForOf,
        NgStyle,
        CommonModule,
        TranslatePipe,
        EvidenceSvgPipe,
        IdCardComponent,
        ProgressSpinnerModule,
        SkeletonModule,
        ReactiveFormsModule
    ],
    templateUrl: './document-signing.component.html',
    styleUrl: './document-signing.component.scss'
})
export class DocumentSigningComponent implements OnInit {

    isSigned: boolean = false;
    signType: SignatureLevel | null = SignatureLevel.BASIC;
    documentData: any[] = [];
    ref!: DynamicDialogRef;
    processId!: string;
    subitemId!: string;
    signaturePosition!: any[];

    pdfDto: PdfDto = {
        fileName: "",
        id: "",
        images: [],
        width: 0,
        height: 0
    };

    selectedFileUrl: SafeResourceUrl | null = null;
    signProcess: SignerModel | null = null;
    signingState: boolean | null = null;

    constructor(private http: HttpClient,
                public dialogService: DialogService,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private sipoService: SipoService,) {
    }


    ngOnInit() {
        this.processId = this.route.snapshot.paramMap.get('processid')!;
        this.subitemId = this.route.snapshot.paramMap.get('sitemid')!;

        (async () => {
            const subItem = await this.getSubItem();
            this.isSigned = subItem.status.localeCompare(SigningStates.FINISHED) == 0;
            this.signingState = this.isSigned
            this.signType = this.setSignatureLevel(subItem.signtType);
            this.loadDocumentForSigning();
        })();


        this.sipoService.getSignerModel(this.processId).subscribe({
            next: (data: SignerModel) => {
                this.signProcess = data;
            },
            error: err => {
                console.log(err);
            }
        })

        this.getSubItems();
    }

    setSignatureLevel(signatureLevel: string) {

        switch (signatureLevel) {
            case 'basic':
                return SignatureLevel.BASIC;
            case 'basiccert':
                return SignatureLevel.BASICCERT;
            case 'extended':
                return SignatureLevel.EXTENDED;
            case 'high':
                return SignatureLevel.MAX;
        }
        return null;
    }

    async getSubItem() {
        const subItem = await this.sipoService.getSigningItemPromise(this.processId, this.subitemId);

        console.log(subItem)
        return subItem;
    }

    async loadDocumentForSigning() {

        this.documentData = [];
        if (this.processId) {
            this.sipoService.getImagesByProcess(this.processId).subscribe({
                next: value => {
                    this.pdfDto = value;
                    const images = value.images.sort((a, b) => a.pageNumber - b.pageNumber)
                    images.forEach(image => {
                        this.documentData.push(
                            {
                                img: image.data.startsWith("data:image/png;base64,") ? image.data : "data:image/png;base64," + image.data,
                                width: value.width,
                                height: value.height,
                                signaturePosition: {
                                    "bottom": "3%;",
                                    "left": "40%;"
                                }
                            }
                        );
                    });

                    this.sipoService.getPositionsByItem(this.subitemId).subscribe({
                        next: positions => {
                            this.signaturePosition = positions;
                        },
                        error: error => {
                            console.log(error);
                        }
                    });
                },
                error: err => {
                    console.error(err);
                }
            });
        }
    }

    // Sub items will be used to control the signer's sign state. In signModel's signers filed there isn't state.
    subItems: any[] = [];
    isAllSignersSigned!: boolean;
    getSubItems() {

        this.subItems = [];

        this.sipoService.getSubItemsList(this.processId).subscribe({
            next: value => {
                console.log(value);
                this.subItems = value;
                this.isAllSignersSigned = value.every((signer: any) => signer.status === 'finished');
            },
            error: err => {
                console.error(err)
            }
        })
    }

    signDocumentItem(type: SignatureLevel) {

        this.ref = this.dialogService.open(ConfirmDocumentSignComponent, {
            width: '45rem',
            height: '45rem',
            maximizable: false,
            data: {
                processId: this.processId,
                subitemId: this.subitemId,
                signType: type
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {

                console.log(value);
            }
        });
    }

    signDocumentItemSign() {

        console.log("", this.signType);
        this.ref = this.dialogService.open(ConfirmDocumentSignComponent, {
            // header: "Sign document",
            width: '45rem',
            height: '30rem',
            maximizable: false,
            data: {
                processId: this.processId,
                subitemId: this.subitemId,
                signType: this.signType
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
                this.signingState = value;
                console.log(value);
            }
        });
    }

    showOTP() {

        this.ref = this.dialogService.open(OtpComponent, {
            header: "OTP",
            width: '25rem',
            height: '25rem',
            data: {},

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
                console.log(value);
            }
        });
    }


    convertPdfCoordsToCss(
        pdfX: number,
        pdfY: number,
        pdfWidth: number,
        pdfHeight: number,
        imageWidth: number,
        imageHeight: number
    ): { left: number; top: number } {
        const scaleX = imageWidth / pdfWidth;
        const scaleY = imageHeight / pdfHeight;

        const left = pdfX * scaleX;
        const top = imageHeight - (pdfY * scaleY); // Flip Y-Achse (PDF → CSS)

        return {left, top};
    }


    getCssPosition(pdfX: number, pdfY: number, imageWidth: number, imageHeight: number): { [key: string]: string } {
        const PDF_WIDTH = 595.28;
        const PDF_HEIGHT = 841.89;

        const {left, top} = this.convertPdfCoordsToCss(pdfX, pdfY, PDF_WIDTH, PDF_HEIGHT, imageWidth, imageHeight);

        return {
            left: `${pdfX}px`,
            top: `${pdfY}px`
        };
    }


    selectedFileName: string | null = null;
    currentBlob: Blob | null = null;


    viewFile(file: FileModel): void {
        const pdfBlob = this.base64ToBlob(file.content, 'application/pdf');
        const url = URL.createObjectURL(pdfBlob);
        this.selectedFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFileName = file.name;
        this.currentBlob = pdfBlob;
    }

    downloadFile(): void {
        if (!this.currentBlob || !this.selectedFileName) {
            return;
        }
        const link = document.createElement('a');
        link.href = URL.createObjectURL(this.currentBlob);
        link.download = this.selectedFileName;
        link.click();
        URL.revokeObjectURL(link.href);
    }

    openInNewTab(file: FileModel): void {
        const blob = this.base64ToBlob(file.content, 'application/pdf');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    }

    base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: contentType});
    }


    // Map der aktuell gerenderten Seitengrößen (CSS px): pageNumber -> {w,h}
    private pageRenderSize = new Map<number, { w: number; h: number }>();

    /** Wird aufgerufen, sobald ein Seitenbild gerendert ist (onload) */
    onPageImgLoad(pageNumber: number, imgEl: HTMLImageElement) {
        const rect = imgEl.getBoundingClientRect();
        this.pageRenderSize.set(pageNumber, { w: rect.width, h: rect.height });
    }

    /** Positionen je Seite filtern */
    positionsForPage(pageNumber: number) {
        return (this.signaturePosition ?? []).filter(p => p.pageNumber === pageNumber);
    }

    /** X/Y skalieren: gespeicherte Drop-Koordinate → aktuelle Anzeigegröße */
    scaleX(pos: { x: number; pageNumber: number; displayWidth: number; }): number {
        const size = this.pageRenderSize.get(pos.pageNumber);
        if (!size || !pos.displayWidth) return pos.x; // Fallback: unskaliert
        const sx = size.w / pos.displayWidth;
        return pos.x * sx;
    }

    scaleY(pos: { y: number; pageNumber: number; displayHeight: number; }): number {
        const size = this.pageRenderSize.get(pos.pageNumber);
        if (!size || !pos.displayHeight) return pos.y; // Fallback: unskaliert
        const sy = size.h / pos.displayHeight;
        return pos.y * sy;
    }

}
